import { useState, useEffect, useCallback } from "react";
import { doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

const VAPID_PUBLIC_KEY = "BIiuqu-rMCnjGzz11hBIzWjU16prUJfxCTWoTGS1t5z2Iw7KxfwxXq5fViNdE2wtgw4WMtWBzUnqbClr_aeMYyY"; // replace with your generated key

function urlBase64ToUint8Array(base64String) {
	const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
	const rawData = atob(base64);
	return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

function subIdFor(endpoint) {
	return btoa(endpoint).replace(/[^a-zA-Z0-9]/g, "").slice(0, 100);
}

export function usePushNotifications(adminEmail) {
	const [permission, setPermission] = useState(
		typeof Notification !== "undefined" ? Notification.permission : "unsupported"
	);
	const [subscribed, setSubscribed] = useState(false);
	const [supported, setSupported] = useState(true);

	useEffect(() => {
		if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
			setSupported(false);
			return;
		}
		navigator.serviceWorker.register("/sw.js").then(async (reg) => {
			const sub = await reg.pushManager.getSubscription();
			setSubscribed(!!sub);
		});
	}, []);

	const subscribe = useCallback(async () => {
		if (!supported) return;
		const perm = await Notification.requestPermission();
		setPermission(perm);
		if (perm !== "granted") return;

		const reg = await navigator.serviceWorker.register("/sw.js");
		const sub = await reg.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
		});

		await setDoc(doc(db, "pushSubscriptions", subIdFor(sub.endpoint)), {
			subscription: sub.toJSON(),
			adminEmail: adminEmail || null,
			createdAt: new Date(),
		});
		setSubscribed(true);
	}, [adminEmail, supported]);

	const unsubscribe = useCallback(async () => {
		const reg = await navigator.serviceWorker.getRegistration();
		const sub = await reg?.pushManager.getSubscription();
		if (sub) {
			await deleteDoc(doc(db, "pushSubscriptions", subIdFor(sub.endpoint)));
			await sub.unsubscribe();
		}
		setSubscribed(false);
	}, []);

	return { permission, subscribed, supported, subscribe, unsubscribe };
}